var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEuFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 507,
    viewBox: "0 0 507 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_2216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.18 506.36C393.007 506.36 506.36 393.007 506.36 253.18C506.36 113.353 393.007 0 253.18 0C113.353 0 0 113.353 0 253.18C0 393.007 113.353 506.36 253.18 506.36Z",
    fill: "#243E90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.18 46.1396L260.04 66.5097L281.54 66.7396L264.28 79.5596L270.71 100.07L253.18 87.6197L235.66 100.07L242.09 79.5596L224.83 66.7396L246.32 66.5097L253.18 46.1396Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.54 70.29L350.4 90.67L371.89 90.89L354.63 103.71L361.06 124.23L343.54 111.78L326.01 124.23L332.44 103.71L315.18 90.89L336.68 90.67L343.54 70.29Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04 135.8L415.9 156.17L437.4 156.4L420.14 169.22L426.57 189.73L409.04 177.28L391.52 189.73L397.94 169.22L380.69 156.4L402.18 156.17L409.04 135.8Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.32 226.15L440.18 246.52L461.68 246.75L444.42 259.57L450.85 280.08L433.32 267.64L415.8 280.08L422.23 259.57L404.97 246.75L426.47 246.52L433.32 226.15Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.04 316.51L415.9 336.88L437.4 337.11L420.14 349.92L426.57 370.44L409.04 357.99L391.52 370.44L397.94 349.92L380.69 337.11L402.18 336.88L409.04 316.51Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.54 382.58L350.4 402.95L371.89 403.18L354.63 415.99L361.06 436.51L343.54 424.06L326.01 436.51L332.44 415.99L315.18 403.18L336.68 402.95L343.54 382.58Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.18 406.29L260.04 426.67L281.54 426.89L264.28 439.71L270.71 460.23L253.18 447.78L235.66 460.23L242.09 439.71L224.83 426.89L246.32 426.67L253.18 406.29Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 382.58L170.25 402.95L191.75 403.18L174.49 415.99L180.92 436.51L163.4 424.06L145.87 436.51L152.3 415.99L135.04 403.18L156.54 402.95L163.4 382.58Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3197 316.51L104.18 336.88L125.68 337.11L108.42 349.92L114.85 370.44L97.3197 357.99L79.7997 370.44L86.2297 349.92L68.9697 337.11L90.4697 336.88L97.3197 316.51Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0404 226.15L79.9004 246.52L101.4 246.75L84.1404 259.57L90.5704 280.08L73.0404 267.64L55.5204 280.08L61.9404 259.57L44.6904 246.75L66.1804 246.52L73.0404 226.15Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3197 135.8L104.18 156.17L125.68 156.4L108.42 169.22L114.85 189.73L97.3197 177.28L79.7997 189.73L86.2297 169.22L68.9697 156.4L90.4697 156.17L97.3197 135.8Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4 70.29L170.25 90.67L191.75 90.89L174.49 103.71L180.92 124.23L163.4 111.78L145.87 124.23L152.3 103.71L135.04 90.89L156.54 90.67L163.4 70.29Z",
    fill: "#FFCD05",
    stroke: "#FFCE08",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_2216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 506.37,
    height: 506.37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuFlag);
export default __webpack_public_path__ + "static/media/euFlag.aa9de3549bb3c6905eb56be42c8d0698.svg";
export { ForwardRef as ReactComponent };